import axios from 'axios';
import { EventData } from '../models/EventData';

interface ApiError {
    error_code: number;
    message: string;
}

interface ApiResponse<T> {
    success: boolean;
    data?: T;
    error?: ApiError[];
}

export const getAuthUrl = async (): Promise<string> => {
    const { data } = await axios.post<ApiResponse<{ url: string }>>(`/auth/rally`);

    if (data.success && data.data) {
        return data.data.url;
    }

    const message = data.error?.map(({ message }: { message: string }) => message).join(',');
    throw new Error(message);
};

interface PurchaseEventParams {
    event_uuid: string;
    code: string;
}

export const purchaseEvent = async (requestBody: PurchaseEventParams): Promise<EventData> => {
    const { data } = await axios.post<ApiResponse<EventData>>(`/events/purchase_rally`, {
        ...requestBody,
        skipValidation: process.env.NODE_ENV !== 'production',
    });

    if (data.success && data.data) {
        return data.data;
    }

    const message = data.error?.map(({ message }: { message: string }) => message).join(',');
    console.error(message);
    throw new Error(message);
};
